import type React from "react";
import { ReactionFooter } from "@/components/common/ReactionFooter";
import type {
  Reaction,
  ReactionBreakdown,
  ReactionType,
} from "@/lib/humhub-api/types";

interface InteractionFooterProps {
  localReaction: ReactionType | null;
  isReacting?: boolean;
  isPending?: boolean;
  commentId: number;
  onReactionSelect: (reaction: ReactionType) => void | Promise<void>;
  onReplyClick?: (commentId: number) => void;
  showReplyButton: boolean;
  isAnyActionLoading?: boolean;
  reactionTotal?: number;
  lastReactions?: Reaction[];
  reactionBreakdown?: ReactionBreakdown;
  reactionContentId?: number | string;
  reactionObjectModel?: string;
  reactionObjectId?: number | string;
  isCommentActive?: boolean;
  disabled?: boolean;
  dividerClassName?: string;
  reactionInactiveIconOpacityClass?: string;
}

export const InteractionFooter: React.FC<InteractionFooterProps> = ({
  localReaction,
  isReacting = false,
  isPending = false,
  commentId,
  onReactionSelect,
  onReplyClick,
  showReplyButton,
  isAnyActionLoading = false,
  reactionTotal = 0,
  lastReactions = [],
  reactionBreakdown,
  reactionContentId,
  reactionObjectModel,
  reactionObjectId,
  isCommentActive = false,
  disabled = false,
  dividerClassName = "border-gray-300",
  reactionInactiveIconOpacityClass,
}) => {
  const handleReplyButtonClick = () => {
    if (onReplyClick && commentId) {
      onReplyClick(commentId);
    }
  };

  return (
    <ReactionFooter
      localReaction={localReaction}
      onReactionSelect={onReactionSelect}
      isReacting={isReacting}
      isPending={isPending}
      isAnyActionLoading={isAnyActionLoading}
      disabled={disabled}
      reactionTotal={reactionTotal}
      lastReactions={lastReactions}
      reactionBreakdown={reactionBreakdown}
      reactionContentId={reactionContentId}
      reactionObjectModel={reactionObjectModel}
      reactionObjectId={reactionObjectId}
      showCommentButton={showReplyButton}
      onCommentClick={handleReplyButtonClick}
      isCommentActive={isCommentActive}
      dividerClassName={`ml-10 mt-0 border-t pt-0 ${dividerClassName}`}
      reactionInactiveIconOpacityClass={reactionInactiveIconOpacityClass}
    />
  );
};
